/**
 *  使用方法 Log.config(options);
 *  @param : options = {
 *              app_id : string, //fenglin_liu提供，跟product_name绑定
 *              app_version : string, //产品版本号，如1.8
 *              user_id : string, //用户id
 *              client_id : string, //客户id
 *              device_id: string, //设备id
 *              lc: string, //语言
 *              auto_page : bool, //是否开启自动pv统计
 *          }
 *   Log.page(page_id, object)
 *   Log.action(action_id, object)
 *   Log.trace(trace_id, object)
 *   Log.tracePerformance(action_id);
 *   performance_timing : 默认统计页面加载性能时间
 *   residence_time : 默认统计页面停留时间
 */
let app_id = ''
let app_version = ''
let lc = ''
let user_id = ''
let cur_page_id = ''
let last_page_id = ''
let get_page_id = ''
const client_id_key = 'ccint_log_client_id'
let client_id = localStorage.getItem(client_id_key)
let device_id = ''
let product_name = ''
let env = 'DEV'
let api_url
let from = ''
let start_time = +new Date()
let is_ready = false

if (!client_id) {
  client_id = _randomString(10)
  localStorage.setItem(client_id_key, client_id)
}

function _randomString(len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

/*
 readyStart：浏览器准备新页面耗时
 redirectTime：重定向耗时
 unloadEventTime：卸载前文档耗时
 lookupDomainTime： DNS查询耗时
 connectTime：TCP连接耗时
 requestTime：请求耗时
 initDomTreeTime：dom加载耗时
 domReadyTime：dom解析耗时
 loadTime：加载总时间
 example :  $(window).bind('load', function () {
 Log.actionPerformance();
 });
 */
function _tracePerformance(trace_id) {
  const timing = performance.timing
  const tmp_obj = {
    readyStart: timing.fetchStart - timing.navigationStart,
    redirectTime: timing.redirectEnd - timing.redirectStart,
    unloadEventTime: timing.unloadEventEnd - timing.unloadEventStart,
    lookupDomainTime: timing.domainLookupEnd - timing.domainLookupStart,
    connectTime: timing.connectEnd - timing.connectStart,
    requestTime: timing.responseEnd - timing.requestStart,
    initDomTreeTime: timing.domInteractive - timing.responseEnd,
    domReadyTime: timing.domComplete - timing.domInteractive,
    loadTime: timing.loadEventEnd - timing.navigationStart
  }
  trace(trace_id || 'performance_timing', tmp_obj)
}

function tracePerformance(trace_id) {
  if (!window.performance || !performance.timing) {
    return
  }
  if (document.readyState === 'complete') {
    _tracePerformance(trace_id)
  } else {
    window.addEventListener('load', function () {
      setTimeout(function () {
        _tracePerformance(trace_id)
      }, 0)
    })
  }
}

function setFrom(str) {
  from = str || cur_page_id
}

function getFrom() {
  return from
}

function setUserId(str) {
  user_id = str
}

function getPageId(url) {
  let path_name
  if (url) {
    const tmpEle = document.createElement('a')
    tmpEle.href = url
    if (tmpEle.host !== location.host) {
      return url
    }
    path_name = tmpEle.pathname
  } else {
    path_name = location.pathname
  }
  return path_name.substr(1).replace('/', '_')
}

function config(data) {
  if (is_ready) {
    return
  }
  app_id = data.app_id || ''
  app_version = data.app_version || ''
  user_id = data.user_id || ''
  product_name = data.product_name || ''
  from = data.from || getUrlParam('from') || ''
  env = data.env ? data.env.toLowerCase() : 'dev'
  lc = data.lc || 'zh-cn'
  client_id = data.client_id || client_id
  device_id = data.device_id || ''
  get_page_id = data.get_page_id || getPageId
  if (env === 'online' || env === 'pre') {
    api_url = 'https://logio.intsig.net/logapi/cc.gif'
  } else {
    api_url = 'https://logio-sandbox.intsig.net/logapi/cc.gif'
  }
  let unload_event = 'beforeunload'
  if (
    /iphone|ipad|ios/i.test(navigator.userAgent) &&
    (window.onpagehide || window.onpagehide === null)
  ) {
    unload_event = 'pagehide'
  }
  window.addEventListener(unload_event, function () {
    const end_time = +new Date()
    trace('residence_time', {
      time: end_time - start_time
    })
  })
  is_ready = true
  if (data.auto_page) {
    page()
  }
}

function extend(ob1, ob2) {
  for (var i in ob2) {
    if (Object.prototype.hasOwnProperty.call(ob2, i)) {
      ob1[i] = ob2[i]
    }
  }
  return ob1
}

function getUrlParam(key) {
  let i
  let length
  let val = ''
  let query
  let list
  let item

  let s = location.href
  s = s.replace(/#.+$/, '')
  const pos = s.indexOf('?')
  if (pos > -1) {
    s = s.substring(pos, s.length)
  }

  if (s.substr(0, 1) === '?' && s.length > 1) {
    query = s.substring(1, s.length)
    list = query.split('&')

    for (i = 0, length = list.length; i < length; i++) {
      item = list[i].split('=')
      if (item[0] === key && item.length === 2) {
        val = decodeURIComponent(item[1])
        break
      }
    }
  }
  return val
}

function jsonToQueryString(params) {
  let is_first = true
  let query_string = ''
  for (var i in params) {
    if (Object.prototype.hasOwnProperty.call(params, i)) {
      if (!is_first) {
        query_string += '&'
      } else {
        query_string += '?'
        is_first = false
      }
      query_string += encodeURIComponent(i) + '=' + encodeURIComponent(params[i])
    }
  }
  return query_string
}

function getDefaultData() {
  return {
    appid: app_id,
    ui: user_id,
    pn: product_name,
    pv: app_version,
    ci: client_id,
    di: device_id,
    rf: from,
    lc: lc,
    ul: location.href,
    sr: window.outerWidth + '*' + window.outerHeight,
    vp: window.innerWidth + '*' + window.innerHeight,
    t: +new Date()
  }
}

function index(key) {
  window.console && window.console.log && window.console.log(key)
}

function stat(data) {
  if (!api_url || !product_name || !data || typeof data !== 'object') {
    return
  }
  const stat_url = api_url + jsonToQueryString(extend(getDefaultData(), data))

  if (navigator.sendBeacon && !/ios|iphone|ipad/i.test(navigator.userAgent)) {
    try {
      if (!navigator.sendBeacon(stat_url)) {
        new Image().src = stat_url
      }
    } catch (e) {
      new Image().src = stat_url
    }
  } else {
    new Image().src = stat_url
  }
}

function page(page_id, data) {
  last_page_id = cur_page_id
  if (last_page_id) {
    const end_time = +new Date()
    trace('residence_time', {
      time: end_time - start_time
    })
    start_time = end_time
  }
  cur_page_id = page_id || get_page_id() || '/'
  data = Object.assign(
    {
      last_page_id:
        last_page_id ||
        getUrlParam('last_page_id') ||
        (document.referrer && get_page_id && get_page_id(document.referrer))
    },
    data
  )
  const channel = getUrlParam('channel')
  if (channel) {
    data.channel = channel
  }
  stat({
    d: data ? JSON.stringify(data) : '',
    pi: cur_page_id
  })
}

function action(action_id, data, page_id) {
  if (!action_id) {
    index('action_id not set')
    return
  }
  if (!cur_page_id && !page_id) {
    index('page_id not set')
    return
  }
  data = Object.assign(
    {
      last_page_id:
        last_page_id ||
        getUrlParam('last_page_id') ||
        (document.referrer && get_page_id(document.referrer))
    },
    data
  )
  stat({
    d: data ? JSON.stringify(data) : '',
    pi: page_id || cur_page_id,
    ai: action_id
  })
}

function trace(trace_id, data) {
  if (!trace_id) {
    index('trace_id not set')
    return
  }
  if (!cur_page_id) {
    index('page_id not set')
    return
  }
  stat({
    d: data ? JSON.stringify(data) : '',
    pi: cur_page_id,
    ti: trace_id
  })
}

function getCurrentPageId() {
  return cur_page_id
}

// 自动化配置
let page_config = document.getElementById('page_config')
if (page_config) {
  try {
    page_config = JSON.parse(page_config.textContent)
    const log_config = page_config.LOG_CONFIG
    if (log_config) {
      config(log_config)
    }
  } catch (e) {}
}

export default {
  page,
  action,
  trace,
  tracePerformance,
  config,
  getCurrentPageId,
  setFrom,
  getFrom,
  setUserId,
  getPageId
}
